import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/tr';
import 'dayjs/locale/ru';

// Import translation files
import de from './de.json';
import en from './en.json';
import tr from './tr.json';
import ru from './ru.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  tr: { translation: tr },
  ru: { translation: ru }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('locale') || 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

// Configure dayjs locales
i18n.on('languageChanged', (lng) => {
  dayjs.locale(lng);
  localStorage.setItem('locale', lng);
});

// Set initial dayjs locale
dayjs.locale(i18n.language);

export default i18n;
